"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchEvent = exports.subscribeToNotifications = exports.createEvent = void 0;
const EVENT_NAME = 'notification';
const createEvent = (data) => {
    return new CustomEvent(EVENT_NAME, { detail: data });
};
exports.createEvent = createEvent;
const subscribeToNotifications = (callback) => {
    const handler = (e) => {
        callback(e.detail);
    };
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
};
exports.subscribeToNotifications = subscribeToNotifications;
const dispatchEvent = (data) => {
    window.dispatchEvent((0, exports.createEvent)(data));
};
exports.dispatchEvent = dispatchEvent;
